import { render, staticRenderFns } from "./exam_go_no_go.vue?vue&type=template&id=4c86ef0c&scoped=true&"
import script from "./exam_go_no_go.vue?vue&type=script&lang=js&"
export * from "./exam_go_no_go.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c86ef0c",
  null
  
)

export default component.exports